import { render } from "./ModalBatal.vue?vue&type=template&id=6f2c01e7&scoped=true"
import script from "./ModalBatal.vue?vue&type=script&lang=js"
export * from "./ModalBatal.vue?vue&type=script&lang=js"

import "./ModalBatal.vue?vue&type=style&index=0&id=6f2c01e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2c01e7"]])

export default __exports__